import { Field } from "formik";
import React from "react";
import { useRuleFieldSchema } from "containers/Settings/RuleBooks/Schema/schemaContext";
import { withNamespace } from "components/Form/FormikControls";
import { getDataTypeByPath } from "containers/Settings/RuleBooks/Schema/schema";
import {
  FieldValueType,
  FieldValueTypeDisplayNameMap,
} from "containers/Settings/RuleBooks/constants";
import { useFieldSetter } from "hooks";

export interface CountDataSourceField {
  source: "COUNT";
  index: number | "";
  valueType: "integer";
}

interface CountDataSourceProps {
  namespace: string;
  // Array of JSON paths
  options: string[];
  allowFromIndex?: number;

  // A path to disallows from selection from the options list
  // This is used to prevent the user from adding a SUM of a criteria that is
  // accessible via the more direct "FIELD" data source.
  // i.e. Don't allow SUM of a criteria that is the same as the rule's input_field
  excludePath: string;
}

export function CountDataSource(props: CountDataSourceProps) {
  const {
    allowFromIndex = null,
    excludePath,
    namespace: ns,
    options = [],
  } = props;

  const schema = useRuleFieldSchema();

  const setIndex = useFieldSetter(withNamespace(ns, "criteria_output_index"));

  const areOptionsAvailable = Array.isArray(options) && options.length > 0;

  function onChangeIndex({ target: selectEl }) {
    const { selectedIndex } = selectEl;
    setIndex(
      selectedIndex > -1
        ? selectedIndex - 1 // Adjusting for the disabled "Select a Criteria" option
        : // Setting to empty will match the value of the "Select a Criteria" option
          "",
    );
  }

  return (
    <>
      <Field
        as="select"
        className="p-2"
        disabled={!areOptionsAvailable}
        name={withNamespace(ns, "criteria_output_index")}
        onChange={onChangeIndex}
        required
      >
        <option value="" disabled>
          {areOptionsAvailable
            ? "Select a Criteria"
            : "No options are available"}
        </option>
        {options.map((option, index) => {
          const key = `${option}-${index}`;

          const isLessThanMinIndex =
            allowFromIndex !== null && allowFromIndex <= index;
          const isOptionExcluded = option === excludePath;
          const isDisabled = isOptionExcluded || isLessThanMinIndex;

          return (
            <option key={key} value={index} disabled={isDisabled}>
              {getDataTypeByPath(schema, option)?.plural || option} in criteria{" "}
              {index + 1}
            </option>
          );
        })}
      </Field>{" "}
      ({FieldValueTypeDisplayNameMap[FieldValueType.INTEGER]})
    </>
  );
}
